import React from "react";
import { copyToClipboard, errorToast } from "./common/showtoast";
import ApiRequest from "./common/restservice";
import Marquee from "react-fast-marquee";
export default class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Affiliatelink: "http://app.sparkstarns.com/office/#/register",
      Announcement: "",
      active_direct_sponsor_count: "0",
      availablePaywallet: "0.00",
      availablecompanywallet: "0.00",
      businessleft: "0.00",
      businessleftRP: "0.00",
      businessright: "0.00",
      businessrightRP: "0.00",
      leftteamactivemember: 0,
      leftteamtotalmember: 0,
      joiningbonus: "0.00",
      repurchasebonus: "0.00",
      tds: "0",
      position: "",
      rightteamactivemember: 0,
      total_team_count: 0,
      rightteamtotalmember: 0,
      teamtotalmember: 0,
      total_direct_sponsor_count: "0",
      totalactivemember: 0,
      totalbonus: "0.00",
      totalbusiness: "0.00",
      totalbusinessRP: "0.00",
      activepackage: "-",
      username: "001"
    }
  }
  componentDidMount() {
    this.mounted = true;
    this.GetDashboardDetails();
  }
  componentWillUnmount() {
    this.mounted = false;
  }

  async GetDashboardDetails() {
    if (this.mounted) {
      let res = await ApiRequest("GetDashboardDetails.asp", "GET", null, { Authorization: localStorage.getItem("token") });
      console.log(res);
      if (res.status === "error") {
        errorToast(res.message);
        if (res.message === "Session Expired") {
          localStorage.clear();
          this.props.history.push("/login");
        }
        return;
      }
      res.Affiliatelink = "http://app.sparkstarns.com/office/#/register/" + localStorage.getItem("username")
      if (this.mounted)
        this.setState(res);
    }
  }

  render() {
    return (
      <div>
        <div className="page-header">
          <div className="page-leftheader">
            <h4 className="page-title mb-0">Hi! Welcome Back to Spark Nature Solution</h4>
            <ol className="breadcrumb">
              <li className="breadcrumb-item"><label><i className="fe fe-home mr-2 fs-14"></i>Main</label></li>

              <li className="breadcrumb-item active" aria-current="page"><label>Dashboard</label></li>
            </ol>
          </div>
        </div>
        <div className="row" style={{ color: "white" }}>
          <div className=" col-lg-12">
            <div className="card overflow-hidden dash1-card border-0">
              <div className="card-body row">
                <div className="col-lg-12 col-md-12" style={{ color: "black" }}>
                  <h5 className=" mt-1 mb-2">News</h5>
                  <Marquee className="mb-2" style={{ minHeight: 100, fontSize: 16 }}>{this.state.Announcement ? this.state.Announcement : "-"}</Marquee>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-12">
            <div className="card overflow-hidden dash1-card border-0 bg-color-6" style={{ color: "white" }}>
              <div className="card-body">
                <p className=" mb-1 ">Payout Wallet</p>
                <h5 className="number-font" style={{ marginBottom: "0px", marginTop: "5px" }}>{this.state.availablePaywallet}</h5>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-12">
            <div className="card overflow-hidden dash1-card border-0 bg-color-4">
              <div className="card-body">
                <p className=" mb-1 ">Total Bonus</p>
                <h5 className="number-font" style={{ marginBottom: "0px", marginTop: "5px" }}>{this.state.totalbonus}</h5>

              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-12">
            <div className="card overflow-hidden dash1-card border-0 bg-color-6">
              <div className="card-body">
                <p className=" mb-1 ">Direct Referal</p>
                <h5 className="number-font" style={{ marginBottom: "0px", marginTop: "5px" }}>{this.state.total_direct_sponsor_count}</h5>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-12">
            <div className="card overflow-hidden dash1-card border-0 bg-color-4">
              <div className="card-body">
                <p className=" mb-1 ">Current Package</p>
                <h5 className="number-font" style={{ marginBottom: "0px", marginTop: "5px" }}>{this.state.activepackage}</h5>
              </div>
            </div>
          </div>
        </div>

        <div className="row mt-2" >

          <div className="col-lg-3">
            <div className="card card-body br-top border-color-6">
              <div className="media">
                <div className="mr-3">
                  <label>
                    <div className="wallet_bal"><i className="icon-user text-color-6"></i></div>
                  </label>
                </div>

                <div className="media-body">
                  <h4 className="text-right mb-0">{this.state.total_team_count}</h4>
                  <div className="text-muted text-right">Total Team</div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="card card-body br-top  border-color-6">
              <div className="media">
                <div className="mr-3">
                  <label>
                    <div className="wallet_bal"><i className="icon-people text-color-6"></i></div>
                  </label>
                </div>

                <div className="media-body" onClick={() => {
                  copyToClipboard(this.state.Affiliatelink);
                }} style={{ cursor: "pointer" }}>
                  <h4 className="text-right mb-0">{this.state.Affiliatelink}</h4>
                  <div className="text-muted text-right">Affiliate Link</div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-3">
            <div className="card card-body br-top border-color-6">
              <div className="media">
                <div className="mr-3">
                  <label>
                    <div className="wallet_bal"><i className="icon-equalizer text-color-6"></i></div>
                  </label>
                </div>

                <div className="media-body float-right pull-right">
                  <h4 className="text-right mb-0"> {this.state.total_direct_sponsor_count}</h4>
                  <div className="text-muted text-right">Total Direct</div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}